<template>
    <v-container>
        <v-row>
            <v-col cols="8">
                <v-row>
                    <v-col cols="12">
                        <v-card
                            class="mx-auto"
                            :outlined="parentOutline"
                            :elevation="parentElevation"
                            @click="selectParent"
                        >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-row class="mx-0 my-0 px-0 py-0">
                                        <v-col>
                                            <div class="overline" style="width: 100%">
                                                Route: {{ selectedRoute[0].name }} 
                                            </div>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col class="mb-0">
                                            <v-btn fab small light depressed class="mr-4">
                                                <v-icon>mdi-message-text</v-icon>
                                            </v-btn>
                                            <v-btn fab small light depressed class="mr-4">
                                                <v-icon>mdi-folder</v-icon>
                                            </v-btn>
                                            <v-btn fab small light depressed class="mr-4" @click="openReceiverModal()">
                                                <v-icon>mdi-account-plus</v-icon>
                                            </v-btn>
                                            <v-btn fab small light depressed class="mr-4">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    
                                    <v-divider class="mb-5"></v-divider>
                                    <v-row>
                                        <v-col lg="6">
                                            <v-list-item-subtitle class="mb-4">
                                                Initiator: {{ selectedRoute[0].user.first_name }} {{ selectedRoute[0].user.middle_name }} {{ selectedRoute[0].user.last_name }}
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                Label: {{ selectedRoute[0].label }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col lg="6">
                                            <v-list-item-subtitle class="mb-4">
                                                 <v-icon>mdi-clock-outline</v-icon> PCT: {{ selectedRoute[0].datetime_due }}
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle class="pl-7">
                                                Status: {{ selectedRoute[0].status }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card>
                    </v-col>
                </v-row>
                <v-divider class="mt-2 mb-5"></v-divider>
                <h3 class="mb-6">User Route Assignments</h3>
                <v-row
                    v-scroll:#scroll-target="onScroll"
                    style="height: 400px; overflow: auto; overflow-x: hidden;"
                >
                    <v-col cols="12">
                        <div v-for="child in selectedRouteAssignments" :key="child.id" >
                            <v-row>
                                <v-col cols="12">
                                    <v-card
                                        @click="selectChild(child.id)"
                                        class="mx-auto"
                                        :outlined="(selectedChildId === child.id) ? childOutline : true"
                                        :elevation="(selectedChildId === child.id) ? childElevation : 0"
                                    >
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <v-row class="mx-0 my-0 px-0 py-0">
                                                    <v-col>
                                                        <div class="overline" style="width: 100%">
                                                            Route: {{ child.name }}
                                                        </div>
                                                    </v-col>
                                                    <v-spacer style="margin-right: 150px;"></v-spacer>
                                                    <v-col class="mb-0">
                                                        <v-btn fab small light depressed class="mr-4">
                                                            <v-icon>mdi-message-text</v-icon>
                                                        </v-btn>
                                                        <v-btn fab small light depressed class="mr-4">
                                                            <v-icon>mdi-folder</v-icon>
                                                        </v-btn>
                                                        <v-btn fab small light depressed class="mr-4">
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                                
                                                <v-divider class="mb-5"></v-divider>
                                                <v-row>
                                                <v-col lg="6">
                                                    <v-list-item-subtitle class="mb-4">
                                                        Assigned: {{ child.user.first_name }} {{ child.user.middle_name }} {{ child.user.last_name }}
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        Action: {{ child.action.name }}
                                                    </v-list-item-subtitle>
                                                </v-col>
                                                <v-col lg="6">
                                                    <v-list-item-subtitle class="mb-4">
                                                        <v-icon>mdi-clock-outline</v-icon> PCT: {{ child.datetime_due }}
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle class="pl-7">
                                                        Status: {{ child.status }}
                                                    </v-list-item-subtitle>
                                                </v-col>
                                            </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-row>
                    <v-col cols="12">
                        <div class="record-box">
                            <div class="box-title">
                                Documents
                            </div>
                            <ul v-for="document in selectedDocuments" :key="document.id">
                                <li>{{ document.name }} </li>
                            </ul>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="record-box">
                            <div class="box-title">
                                Records
                            </div>
                            <ul v-for="record in selectedRecords" :key="record.id">
                                <li>{{ record.name }} </li>
                            </ul>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <AddReceiverModal :dialog="receiver_dialog" :addFromRoute="addReceiver" @closeDialog="closeReceiverDialog" />
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddReceiverModal from '../../components/AddReceiverModal';

export default {
    name: "RouteDetails",
    components: {
        AddReceiverModal
    },
    data() {
        return {
            routeId: this.$route.params.id,
            offsetTop: 0,
            parentOutline: false,
            parentElevation: 5,
            selectedChildId: null,
            childOutline: true,
            childElevation: 0,
            receiver_dialog: false,
            addReceiver: true,
        }
    },
    methods: {
        ...mapActions(['fetchSelectedRoute']),
        onScroll (e) {
            this.offsetTop = e.target.scrollTop
        },
        selectParent() {
            this.selectedChildId = null;
            this.childOutline = true;
            this.childElevation = 0;
            this.parentOutline = false;
            this.parentElevation = 5;

        },
        selectChild(id) {
            this.selectedChildId = id;
            this.parentOutline = true;
            this.parentElevation = 0;
            this.childOutline = false;
            this.childElevation = 5;
        },
        openReceiverModal() {
            this.receiver_dialog = true;
        },
        closeReceiverDialog() {
            this.receiver_dialog = false;
        }
    },
    computed: mapGetters(['selectedRoute', 'selectedRecords', 'selectedDocuments', 'selectedRouteAssignments']),
    created () {
        this.fetchSelectedRoute(this.routeId);
    },
}
</script>

<style scoped>
    .assigned-routes {
        border-style: solid;
        border-color: green;
        overflow: auto;
        overflow-x: hidden;
        height: 500px;
    }

    .record-box {
        overflow: auto;
        overflow-x:hidden;
        height: 300px;
        border-style: solid;
        border-width: thin;
        border-color: #d1d1d1;
    }

    ul {
        padding: 0px;
        margin-top: 0px;
    }

    li {
        list-style: none;
        border-bottom: solid;
        border-width: thin;
        border-bottom-color: gray;
        padding-bottom: 6px;
        padding-top: 6px;
        cursor: pointer;
        color: #6b6b6b;
        padding-left: 15px;
        font-size: 14px;
    }
    
    li:hover {
        background-color: rgb(230, 230, 230);
    }

    .box-title {
        background-color: #dfdfdf;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 10px;
    }
</style>>